export const mapDetalleToLine = (detalle) => ({
    id: detalle.id || Date.now(),
    referencia: detalle.producto?.codigo || '',
    nombre: detalle.producto?.descripcion || '',
    descripcion: detalle.producto?.descripcion || '',
    um: detalle.producto?.unidad || '',
    stock: detalle.stock || 0,
    centro: detalle.almacen?.almacen || '',
    precio_lista: detalle.precioLista ?? detalle.precio_lista ?? detalle.precio ?? 0,
    precio: detalle.precio ?? detalle.precioLista ?? detalle.precio_lista ?? 0,
    cantidad: detalle.cantidad ?? 1,
    descuento: detalle.descuento ?? 0,
    flete: detalle.flete,
});